import React from "react";
import { Row } from "reactstrap";
import "./whyToffee.scss";
import WhyToffeeCard from "../../common/cards/WhyToffeeCard";

class WhyToffee extends React.Component {
  state = {
    cards: [
      {
        icon: require("../../../assets/images/icons/leaf.png"),
        title: "Simple, Hassle-Free Process ",
        subTitle:
          "Hassle-free and accessible to everyone, Toffee Insurance covers more, which means, you worry less. So instead of looking for 3 different insurance policies and buying them separately, you buy one plan that gives instant protection to you and your family. "
      },
      {
        icon: require("../../../assets/images/icons/square-heart.png"),
        title: "All-Inclusive Coverage ",
        subTitle:
          "One plan that gives you end-to-end coverage in easy, simple steps across health, life and household (that covers appliances, theft and more). Your premiums are in easy, monthly instalments and insure everyone from a single person to a family of 4.   "
      },
      {
        icon: require("../../../assets/images/icons/circle-check.png"),
        title: "Zero Paperwork",
        subTitle:
          "Unlike typical insurance policies, Toffee Insurance is an online plan that is completely paperless, flexible with your needs and easy to buy."
      },
      {
        icon: require("../../../assets/images/icons/smile.png"),
        title: "Superfast Sign-Up",
        subTitle:
          "Toffee Insurance Plan is a completely online product that makes things worth your time. Our plan is easy to understand and the whole process takes just a couple of minutes to complete. Signed up yet?  "
      },
      {
        icon: require("../../../assets/images/icons/star.png"),
        title: "Someone You Can Trust ",
        subTitle:
          "Toffee is backed by some of the most trusted names in the insurance industry such as Religare, ICICI Health and Chola MS. It’s an exclusive combo-plan which means you pay the lowest possible installments for the best possible insurance partners. "
      },
      {
        icon: require("../../../assets/images/icons/money.png"),
        title: "Customised Monthly Payments ",
        subTitle:
          "Convenience of an easy monthly payment that cuts down your insurance expenses in small bite-sized premiums. You can start, renew and stop when you like or adjust your plan and payments as per your needs. "
      }
    ]
  };
  render() {
    return (
      <div className="why-container">
        <h2 className="title text-center">
          Toffee Insurance is Making Insurance a Little Sweeter
        </h2>
        <h3 className="sub-title text-center">
          One plan. Two coverage options. Three life-long benefits.
        </h3>
        <Row className="m-0 p-0 card-row">
          {this.state.cards.map(card => {
            return <WhyToffeeCard data={card} />;
          })}
        </Row>
      </div>
    );
  }
}

export default WhyToffee;
